<template>
  <div
    class="box-application relative rounded shadow-lg p-4 font-bold text-blue hover:opacity-75 h-full text-center"
  >
    <h3 class="mb-6 text-base text-center ecosystem-application-title">
      {{$t("ecosystem.investor_declaration")}}
    </h3>
    <!-- START APPLICATION DESCRIPTION -->
    <div class="mb-2 m-auto max-w-xs">
      <span>{{ $t('ecosystem.description_investor_declaration') }}</span>
    </div>
    <!-- END APPLICATION DESCRIPTION -->
    <div class="mb-4 h-16">
      <img
        class="fill-current"
        :src="appIcon.path"
        :alt="appIcon.text"
        :title="appIcon.text"
      />
    </div>
    <div class="mb-2" v-if="application">
      <span v-if="application.status == '0'">{{
        $t("candidat.being_entered")
      }}</span>
      <span v-if="['2'].includes(application.status)">{{
        $t("candidat.Awaiting_further_information")
      }}</span>
      <span v-if="application.status == '1'">{{
        $t("candidat.submitted_instruction")
      }}</span>
      <span v-if="application.status == '3'">{{
        $t("candidat.declaration_accepted")
      }}</span>
      <span v-if="application.status == '4'">{{
        $t("candidat.declaration_refused")
      }}</span>
    </div>
    <div v-else class="mb-2 invisible">
      <span>{{ $t("team.status") }}</span>
    </div>
    <div class="mb-2" v-if="application && ['3', '4'].includes(application.status) && application.submit_date">
      <span>{{ application.submit_date }}</span>
    </div>
    <sp-button
      @click="
        application == null
          ? createApp(type.toLowerCase())
          : application.status == '0' || application.status == '2'
          ? consultOrEditApp(application.hash_id, type)
          : consultOrEditApp(application.hash_id, type)
      "
      class="bg-red hover:bg-red text-white font-bold py-2 px-4 rounded inline-flex items-center"
    >
      <img
        v-if="application == null"
        class="fill-current w-4 h-4 mr-2"
        src="../../assets/img/cand/Group Copy 2.svg"
        alt="startup tunisia action"
      />
      <img
        v-else-if="application.status == '0' || application.status == '2'"
        class="fill-current w-4 h-4 mr-2"
        src="../../assets/img/cand/pencil-write.svg"
        alt="startup tunisia action"
      />
      <span v-if="application == null">{{
        type == 'investor' ? $t("ecosystem.new_ecosystem_declaration") : $t("ecosystem.new_ecosystem_app")
      }}</span>
      <span v-else>
        <div v-if="application.status == '0' || application.status == '2'">
          <span>
            {{ type == 'investor' ? $t("ecosystem.edit_declaration") : $t("ecosystem.edit_app") }}
          </span>
        </div>
        <div v-else>
          <span>
            {{ type == 'investor' ? $t("ecosystem.consult_declaration") : $t("ecosystem.consult_app") }}
          </span>
        </div>
      </span>
    </sp-button>
  </div>
</template>

<script>
import Button from "@/components/spKit/Button.vue";
import { Fragment } from "vue-fragment";
import { mapGetters } from "vuex";
import {
  CREATE_ECOSYSTEM_APP,
  FETCH_ECOSYSTEM_APPLICATION
} from "@/store/actions.type";
export default {
  name: "SessionlessApplication",
  components: {
    "sp-button": Button,
    fragment: Fragment
  },
  data() {
    return {
      isCreated: false
    };
  },
  props: {
    type: {
      required: true,
      type: String,
      default: ""
    },
    application: {
      required: false,
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["ecosystemApp", "currentUser"]),
    appIcon() {
      return {
        path: require(`../../assets/img/investor-declaration.svg`),
        text: `Startup Tunisia Déclaration Investisseur Logo`
      };
    }
  },
  mounted() {},
  methods: {
    createApp(type) {
      if (!this.isCreated) {
        let self = this;
        this.isCreated = true;
        this.$store
          .dispatch(CREATE_ECOSYSTEM_APP, type)
          .then(data => {
            localStorage.setItem("ecosystem", true);
            this.$router.push({
              name: self.formatRouteName(data.data.application.route),
              params: {
                formName: data.data.application.route,
                ecoAppId:
                  data.data.application.hash_id || data.data.application.id,
                appType: data.data.application.type.toLowerCase()
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async consultOrEditApp(hashId, type) {
      let self = this;
      await this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, hashId);
      this.$router.push({
        name: self.formatRouteName(this.ecosystemApp.application.route),
        params: {
          formName: this.ecosystemApp.application.route,
          ecoAppId: hashId,
          appType: type.toLowerCase()
        }
      });
    },
    formatRouteName(route) {
      let blocks = route.split("-");
      blocks.forEach(function callback(element, index) {
        blocks[index] = element.charAt(0).toUpperCase() + element.slice(1);
      });
      return blocks.join("");
    }
  }
};
</script>

<style></style>
